import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

interface BillingUsage {
  plan: string
  notifications: number
  live_sessions: number
  api_calls: number
  period_start: string
  period_end: string
}

// Plan limits for calculating usage percentage
const PLAN_LIMITS: Record<string, { notifications: number }> = {
  free: { notifications: 1000 },
  starter: { notifications: 10000 },
  pro: { notifications: 100000 },
  enterprise: { notifications: 1000000 },
}

export function useBillingUsage() {
  return useQuery({
    queryKey: ['billingUsage'],
    queryFn: () => api.get<BillingUsage>('/dashboard/billing/usage'),
    refetchInterval: 60000, // Refresh every minute
  })
}

export function getUsagePercentage(usage: BillingUsage | undefined): number {
  if (!usage) return 0
  const limit = PLAN_LIMITS[usage.plan]?.notifications || PLAN_LIMITS.free.notifications
  return Math.min(Math.round((usage.notifications / limit) * 100), 100)
}

export function getPlanLimit(plan: string): number {
  return PLAN_LIMITS[plan]?.notifications || PLAN_LIMITS.free.notifications
}
